import React from 'react'
import { scaleLinear } from 'd3-scale'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import Timeline from './Timeline'
import MonthFilter, { MONTHS } from './MonthFilter'
import Footer from './Footer'

export default function MapDisplay({
  width,
  progress,
  aspect,
  setProgress,
  maxWidth,
  imageUrl,
  overlays = [],
  placeholderImage,
  endDate,
  started
}) {
  const isSmall = width < maxWidth
  const displayWidth = isSmall ? maxWidth : width
  const offsetTop = 70
  const offsetBottom = 0
  const displayHeight = Math.floor(displayWidth * aspect)

  const [images, setImages] = React.useState([])

  React.useEffect(() => {
    fetch(`${imageUrl}files.json`)
      .then(response => response.json())
      .then(data => {
        const filteredData = data.filter(
          d => d.year < endDate.year || d.month <= endDate.month
        )
        const containsEndDat = filteredData.find(
          d => d.month === endDate.month && d.year === endDate.year
        )
        const images = containsEndDat
          ? filteredData
          : filteredData.concat({
              file: placeholderImage,
              year: endDate.year,
              month: endDate.month,
              placeholder: true
            })
        setImages(images.reverse())
      })
  }, [])

  const [enabledMonths, setEnabledMonths] = React.useState([endDate.month])

  const filteredImages = images.filter(i => enabledMonths.includes(i.month)) //.filter(i => started ? !i.placeholder : true)

  const fileSelector = React.useMemo(
    () =>
      scaleLinear()
        .domain([0, 1])
        .range([0, filteredImages.length - 1]),
    [filteredImages]
  )

  const currentFileIdx = Math.ceil(fileSelector(progress))
  const currentFile = filteredImages[currentFileIdx]

  return (
    <div>
      <div
        style={{
          position: 'relative',
          width: displayWidth,
          height: displayHeight + offsetTop + offsetBottom
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: offsetTop + 3,
            left: (displayWidth - width) * -0.5,
            width: displayWidth,
            height: displayHeight,
            userSelect: 'none'
          }}
        >
          {filteredImages.map(i => (
            <img
              key={i.name}
              style={{
                width: displayWidth,
                height: displayHeight,
                pointerEvents: 'none',
                display: i.file === currentFile.file ? 'block' : 'none',
                userSelect: 'none'
              }}
              src={`${i.placeholder ? '' : imageUrl}${i.file}`}
            />
          ))}
        </div>
        <div
          style={{
            position: 'absolute',
            top: offsetTop,
            left: (displayWidth - width) * -0.5,
            width: displayWidth,
            height: displayHeight,
            pointerEvents: 'none',
            userSelect: 'none'
          }}
        >
          <img
            src={isSmall ? overlays[0] : overlays[1]}
            style={{ userSelect: 'none' }}
          />
        </div>
        {currentFile && currentFile.placeholder && (
          <div
            style={{
              position: 'absolute',
              width: width,
              height: displayHeight,
              top: offsetTop,
              pointerEvents: 'none',
              userSelect: 'none',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <div
              style={{
                width: '40%',
                margin: 'auto',
                textAlign: 'center',
                background: 'rgba(255,255,255,0.25)',
                color: '#fff',
                lineHeight: 1.4,
                padding: 5,
                fontSize: '.8rem'
              }}
            >
              Für den gewählten Zeitraum sind noch keine Daten verfügbar.
            </div>
          </div>
        )}

        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: width,
            height: 30
          }}
        >
          <Timeline
            width={width}
            fileList={images}
            currentFile={currentFile}
            setProgress={setProgress}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            top: 30,
            left: 0,
            width: width,
            height: 40
          }}
        >
          <MonthFilter
            width={width}
            currentFile={currentFile}
            enabledMonths={enabledMonths}
            setEnabledMonths={setEnabledMonths}
          />
        </div>
        <div
          style={{
            position: 'relative',
            width: width,
            height: displayHeight + offsetTop + offsetBottom,
            opacity: started ? 0 : 0.6,
            transition: 'opacity 0.2s',
            pointerEvents: 'none',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-end'
          }}
        >
          <img
            src='scroll-hint.svg'
            style={{
              userSelect: 'none',
              height: Math.min(displayWidth * 0.1, 70)
            }}
          />
        </div>
      </div>
    </div>
  )
}
